import {
  LucideCalendar,
  LucideCalendarClock,
  LucideClipboardCheck,
  LucideLayers,
  LucideTag,
  LucidePackage,
  LucideMapPin,
} from 'lucide-react';

import { CycleCountSchedulesListView } from './_components/counts/_CycleCountSchedulesListView';
import { CycleCountTaskDetailView } from './_components/counts/_CycleCountTaskDetailView';
import { CycleCountTasksListView } from './_components/counts/_CycleCountTasksListView';
import { InventoryLevelsListView } from './_components/levels/_InventoryLevelsListView';
import { InventoryLotsListView } from './_components/lots/_InventoryLotsListView';
import { LotDetailsView } from './_components/lots/_LotDetailsView';
import { InventoryMovementHistoryView } from './_components/movements/_InventoryMovementHistoryView';
import { InventoryPeriodDetailView } from './_components/periods/_InventoryPeriodDetailView';
import { InventoryPeriodsListView } from './_components/periods/_InventoryPeriodsListView';
import { InventoryTagDetailView } from './_components/tags/_InventoryTagDetailView';
import { InventoryTagsListView } from './_components/tags/_InventoryTagsListView';
import { InventoryZonesListView } from './_components/zones/_InventoryZonesListView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/inventory';

export const inventoryRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.inventory.root,
    icon: LucidePackage,
  },
  levels: {
    path: `${basePath}/levels` as const,
    label: (t) => t.menu.inventory.levels,
    icon: LucidePackage,
    component: InventoryLevelsListView,
    requiredPermission: 'inventoryBalanceRead',
  },
  movementHistory: {
    path: `${basePath}/levels/:itemId` as const,
    component: InventoryMovementHistoryView,
  },
  lots: {
    path: `${basePath}/lots` as const,
    label: (t) => t.menu.inventory.lots,
    icon: LucideLayers,
    component: InventoryLotsListView,
    requiredPermission: 'inventoryLotRead',
  },
  lotDetail: {
    path: `${basePath}/lots/:lotId` as const,
    component: LotDetailsView,
  },
  tags: {
    path: `${basePath}/tags` as const,
    label: (t) => t.menu.inventory.tags,
    icon: LucideTag,
    component: InventoryTagsListView,
    requiredPermission: 'inventoryTagRead',
  },
  tagDetail: {
    path: `${basePath}/tags/:tagId` as const,
    component: InventoryTagDetailView,
  },
  zones: {
    path: `${basePath}/zones` as const,
    label: (t) => t.menu.inventory.zones,
    icon: LucideMapPin,
    component: InventoryZonesListView,
    requiredPermission: 'inventoryZoneRead',
  },
  periods: {
    path: `${basePath}/periods` as const,
    label: (t) => t.menu.inventory.periods,
    icon: LucideCalendar,
    component: InventoryPeriodsListView,
  },
  periodDetail: {
    path: `${basePath}/periods/:periodId` as const,
    component: InventoryPeriodDetailView,
  },
  cycleCountSchedules: {
    path: `${basePath}/counts/schedules` as const,
    label: (t) => t.menu.inventory.cycleCountSchedules,
    icon: LucideCalendarClock,
    component: CycleCountSchedulesListView,
  },
  counts: {
    path: `${basePath}/counts/tasks` as const,
    label: (t) => t.menu.inventory.counts,
    icon: LucideClipboardCheck,
    component: CycleCountTasksListView,
  },
  countDetail: {
    path: `${basePath}/counts/tasks/:taskId` as const,
    component: CycleCountTaskDetailView,
  },
});

const inventoryNav = createModuleNav(($) =>
  $(inventoryRoutes.root, [
    $(inventoryRoutes.levels),
    $(inventoryRoutes.movementHistory),
    $(inventoryRoutes.lots),
    $(inventoryRoutes.lotDetail),
    $(inventoryRoutes.tags),
    $(inventoryRoutes.tagDetail),
    $(inventoryRoutes.zones),
    $(inventoryRoutes.periods),
    $(inventoryRoutes.periodDetail),
    $(inventoryRoutes.cycleCountSchedules),
    $(inventoryRoutes.counts),
    $(inventoryRoutes.countDetail),
  ]),
);

export const inventoryModule = createAppModule({
  routes: inventoryRoutes,
  nav: inventoryNav,
});
